export default function getUserAgent(state: any): string | undefined {
  return state.requestInfo.userAgent;
}
